// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Chip, Typography } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';

import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

import useAuth from 'hooks/useAuth';
import { BugReportOutlined, Menu, ReportOutlined } from '@mui/icons-material';
import { constConfig } from 'Constants';
import config from 'config';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();
    const { user } = useAuth();
    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                     
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        // background: theme.palette.mode === 'dark' ? theme.palette.dark.main : '#fff',
                        // color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.main,
                        // border: '1px solid',
                        // borderColor: theme.palette.grey[200],
                        // '&:hover': {
                        //     background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.grey[100],
                        //     color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.dark,
                        //     borderColor: theme.palette.grey[400],
                        // }
                    }}
                    onClick={() => {
                        
                        dispatch(openDrawer(!drawerOpen))
                    }
                    }
                    color="inherit"
                >
                    <Menu   />
                </Avatar>
                <Box component="span" sx={{ mx:1, display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                {user && <Typography variant="h3" >{user.company}</Typography>}
                    
                </Box>
                
            </Box>
            {/* <Box>
                <Typography variant="h3"   sx={{pl:4,color:theme.palette.primary.main}}>
                  {user?.company || 'Back Stage'} Marketing Managment&trade;
                </Typography>
            </Box> */}

            {/* header search */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} >  
                <>
                    {constConfig.env != 'PROD' && 
                     <Chip label={`${constConfig.env} ${config.version_num}`}
                    icon={constConfig.env == 'PRE' ? <ReportOutlined /> : <BugReportOutlined />}
                    variant={constConfig.env == 'PRE' ? 'filled' : 'outlined'}
                    color={constConfig.env == 'PRE' ? 'error' : 'info'}  />}
                </>
            </Box>
            <Box sx={{ mr: 1 }} >
                {/* <CurrentAccountTag /> */}
                <LogoSection /> {/* <Typography variant='h3' display='inline' >Back Stage</Typography> */}
            </Box>
            {/* <UtcTime /> */}
            {/* <Box sx={{ mr: 1 }} >
                <LocalizationSection />
            </Box> */}
            {/* mega-menu */}

            {/* live customization & localization */}
            {/* notification & profile */}
            {/* <ProfileSection /> */}

            {/* mobile header */}
            {/* <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box> */}
        </>
    );
};

export default Header;
